import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function sanitizeSlug(input: string): string {
  const decoded = decodeURIComponent(input)
  if (
    !decoded ||
    decoded.includes('/') ||
    decoded.includes('\\') ||
    decoded.includes('..')
  ) {
    throw new Error('Invalid slug', { cause: input })
  }

  return decoded
}